import React, { Component } from 'react';
import { connect } from 'react-redux';
import RecentToastsComponent from './../Components/RecentToastsComponent';
import PropTypes from 'prop-types';
import { toastReducer } from './../reducers';
import { toasts as toastActions } from '../actions';

export class RecentToastsContainer extends Component {
  static propTypes = {
    recentToasts: PropTypes.array.isRequired,
    deleteToast: PropTypes.func.isRequired
  };

  render() {
    return (
      <RecentToastsComponent {...this.props} />
    );
  }
}

export const mapStateToProps = (state) => {
  return { recentToasts: toastReducer.getRecentToasts(state) };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    deleteToast: recentToast =>
      dispatch(toastActions.deleteRecentToast(recentToast))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecentToastsContainer);


// WEBPACK FOOTER //
// src/Containers/RecentToastsContainer.jsx